import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { environment } from 'src/environments/environment';

@Directive({
  selector: '[avatarImage]'
})
export class AvatarImageDirective implements OnInit {

  @Input() set avatarImage(img) {
    if (img && this.el) {
      this.avatarImg = img;
      this.renderer.addClass(this.el.nativeElement, 'user-avatar');
      const blur = this.avatarBlur ? 'e_blur:300' : '';
      const url = img !== '[anonymous]'
        // ? `url(${environment.cloudinaryContentUrl}/w_75,h_75,c_fill${blur}/${img})`
        ? `url(${img})`
        : `url(https://res.cloudinary.com/dteo0axta/image/upload/v1716538102/assets/incognito-avatar_gqxmpl.svg)`;
      this.renderer.setStyle(this.el.nativeElement, 'background-image', url);
    }
  };
  @Input() avatarBlur = false;
  @Input() avatarTitle = null;
  @Input() avatarDefault = false;
  @Input() avatarOrderColor = null;
  @Input() avatarRandomColor = false;
  @Input() avatarColor = null;
  avatarImg = null

  private defaultColorList = [
    '#FFBBBB', '#A3E0FF', '#FFD576', '#CEFF9B', '#FF8888', '#8FF0FF', '#FFA8E1', '#C6F8E3', '#D9AEFF', '#FFB571', '#C0C7FF'
  ];

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit(): void {
    if (this.el && !this.avatarImg) {
      this.renderer.addClass(this.el.nativeElement, 'user-avatar');
      if (this.avatarTitle) {
        const letter = this.avatarTitle.substring(0, 1);
        if (letter) {
          this.renderer.setProperty(this.el.nativeElement, 'innerHTML', letter);
          this.renderer.setStyle(this.el.nativeElement, 'background-image', 'unset');
          if (this.avatarRandomColor && !this.avatarColor && this.avatarOrderColor === null) {
            const color = this.defaultColorList[Math.floor(Math.random() * this.defaultColorList.length)];
            this.renderer.setStyle(this.el.nativeElement, 'background-color', color);
          }
          if (this.avatarOrderColor !== null) {
            const colorIndex = this.getNext(this.avatarOrderColor, this.defaultColorList);
            this.renderer.setStyle(this.el.nativeElement, 'background-color', colorIndex);
          }
          if (this.avatarColor) {
            this.renderer.setStyle(this.el.nativeElement, 'background-color', this.avatarColor);
          }
        }
      }
      if (this.avatarDefault) {
        this.renderer.setStyle(this.el.nativeElement, 'background-image', `url(${environment.cloudinaryContentUrl}${environment.cloudinaryDefaultAvatar})`)
      }
    }
  }

  private getNext = (startIndex, array) => {
    let result;
    for (let i = startIndex; i < array.length + startIndex; i++) {
      if (array[i % array.length]) {
        result = array[i % array.length];
        break;
      }
    }
    return result;
  }

}